export const serviceTemplate = () => ({
  'Sairaanhoito kotiin': {
    akuuttihoito: {
      data: [],
      description: 'Apua äkilliseen tarpeeseen.',
    },
    etälääkärit: {
      data: [],
      description:
        'Lääkärin kotikäynti tai etävastaanotto puhelimen / internetin kautta.',
    },
    haavanhoito: { data: [], description: '' },
    kuulonhuolto: {
      data: [],
      description: 'Esimerkiki kuulolaitteiden huolto.',
    },
    lääkehuolto: { data: [], description: '' },
    verenpaineenmittaus: { data: [], description: '' },
    kotisairaanhoito: {
      data: [],
      description: 'Kotiin vietyä sairaanhoitoa.',
    },
  },
  'Palvelut kotiin': {
    ateriapalvelut: {
      data: [],
      description:
        'Ateriapalvelussa ateria tuodaan asiakkaalle kotiin.',
    },
    hieronta: { data: [], description: '' },
    jalkojenhoito: { data: [], description: '' },
    'kotihoito ja kotipalvelu': {
      data: [],
      description:
        'Hoivaa ja huolenpitoa ja tukemista arjessa, mm. avustaminen ruokailussa, henkilökohtaisen hygienian hoidossa, kuntoutumisessa, liikkumisessa, asioinnissa ja ulkoilussa.',
    },
    kotikuntoutus: {
      data: [],
      description:
        'Kotikuntoutuksella pyritään parantamaan asiakkaan toimintakykyä ja tukemaan selvittymistä päivittäisissä askareissa.',
    },
    kotisiivous: {
      data: [],
      description:
        'Koti siivotaan asiakkaan toiveiden mukaan. Erikseen sovitaan ikkunoiden ja saunan pesusta.',
    },
    kylvetyspalvelut: {
      data: [],
      description:
        'Kylvetys asiakkaan kotona tai päivätoiminnan yhteydessä.',
    },
    pyykinpesu: {
      data: [],
      description:
        'Pyykinpesu asiakkaan kotona tai pyykkipalvelu kodin ulkopuolella.',
    },
    talonmiehet: { data: [], description: '' },
    'ulkoalueiden hoito': {
      data: [],
      description:
        'Pihatöiden tekeminen, esim. ruohonleikkuu ja lumen auraus.',
    },
    'muu vanhusten hoivatyö': {
      data: [],
      description:
        'Tukea kotona pärjäämiseen, hoivaa ja huolenpitoa ja tukemista arjessa.',
    },
  },
  'Muut palvelut ja neuvonta': {
    apteekit: {
      data: [
        {
          // hard-coded pharmacy service
          description: [
            {
              language: 'fi',
              value:
                'Apteekista saat lääkeneuvontaa sekä opastusta lääkkeiden ja muiden apteekissa myytävien tuotteiden käytössä. Lisäksi saat neuvontaa sairauksien lääkkeettömään hoitoon ja terveyden ylläpitoon. Eri apteekit tarjoavat vaihtelevan valikoiman lukuisia muita palveluja, kuten esimerkiksi lääkkeiden annosjakelupalvelua, kotiinkuljetuspalvelua, lääkehoidon turvallisuutta tukevia arviointipalveluja ja liikuntaneuvontaa. Yhä useampi apteekki palvelee myös verkossa. ',
              type: 'Description',
            },
            {
              language: 'fi',
              value:
                'Apteekit tarjoavat lääkeneuvontaa, opastusta lääkkeiden ja tuotteiden käytössä ja neuvontaa terveyttä koskevissa kysymyksissä.',
              type: 'Summary',
            },
          ],
          id: '906c692b-3aff-47e8-9986-3d277928e4f9',
          keys: ['apteekit'],
          languages: ['fi'],
          name: 'Apteekkipalvelut',
          ontologies: [
            'apteekit',
            'käsikauppalääkkeet',
            'lääkkeet',
            'terveysneuvonta',
            'lääkeneuvonta',
          ],
          organizations: [
            'e3823055-7c0c-4115-8059-c43313de961d',
          ],
          serviceChannels: [],
          serviceChargeType: null,
          serviceVoucherInUse: null,
          showInOrganizationViews: true,
        },
      ],
      description: '',
    },
    asiointi: {
      data: [],
      description: 'Apua asiointiin, myös saattoapu',
    },
    digineuvonta: {
      data: [],
      description:
        'Apua digitaalisten laitteiden ja palvelujen käyttöön',
    },
    'henkilökohtaiset avustajat': {
      data: [],
      description:
        'Henkilökohtainen apu toimiin, joista asiakas ei sairauden tai vamman takia selviydy itsenäisesti.',
    },
    hoitotarvikkeet: { data: [], description: '' },
    kaupassakäynti: {
      data: [],
      description:
        'Käydään asiakkaan puolesta kaupassa tai tuetaan kauppatilauksen tekemisessä kotiin',
    },
    keskusteluapu: { data: [], description: '' },
    'kotona asumista tukevat apuvälineet ja teknologia': {
      data: [],
      description:
        'Kotona asumista tukevat apuvälineet ja teknologiat ovat välineitä, laitteita, sovelluksia ja/ tai teknisiä ratkaisuja, joiden tavoitteena on edistää ja ylläpitää hyvinvointia sekä tukea kotona asumista ja hyvää arkea.',
    },
    kuljetuspalvelut: { data: [], description: '' },
    neuvontapalvelut: { data: [], description: '' },
    'pienet sairaanhoidolliset toimenpiteet': {
      data: [],
      description:
        'Vanhusneuvolat ja vastaava toiminta. Korvahuuhtelut, ompeleiden poisto, katetrin vaihto, jne.',
    },
    päihdepalvelut: { data: [], description: '' },
    päivätoiminta: {
      data: [],
      description:
        'Sosiaalista kotona asumista tukevaa toimintaa. Omia voimavaroja vahvistavaa.',
    },
    sielunhoito: {
      data: [],
      description:
        'Sielunhoito tutuimmillaan on auttavaa keskustelua. Oman seurakunnan papin tai diakonin kanssa voi sopia tapaamisen, jossa voi jutella siitä, mikä painaa mieltä.',
    },
    vapaaehtoistyö: {
      data: [],
      description:
        'Mahdollisuuksia osallistua esim. järjestöjen ja yhdistysten toimintaan.',
    },
    vertaistuki: {
      data: [],
      description:
        'Tukea muilta samassa tilanteessa olevilta, esim. vertaisryhmätapaamiset.',
    },
    virkistystoiminta: { data: [], description: '' },
    'muut palvelut': { data: [], description: '' },
  },
  'Isommat teemat': {
    'huoli itsestä tai läheisestä': {
      data: [],
      description:
        'Sosiaalipäivystys, etsivä vanhustyö, jne.',
    },
    mielenterveys: {
      data: [],
      description:
        'Apua ja tukea mielenterveysongelmien kanssa.',
    },
    muistisairaus: {
      data: [],
      description:
        'Muistisairaudella tarkoitetaan sairautta, joka heikentää muistia ja tiedonkäsittelyä sekä muita ajatustoimintoja. ',
    },
    omaishoito: {
      data: [],
      description:
        'Omaishoidolla tarkoitetaan vanhuksen, vammaisen tai sairaan henkilön hoidon ja huolenpidon järjestämistä kotioloissa omaisen tai muun läheisen henkilön avulla.',
    },
    saattohoito: {
      data: [],
      description:
        'Saattohoito on kuolevan ihmisen hoitoa hänen viimeisinä viikkoinaan tai kuukausinaan ennen kuolemaa.',
    },
    senioriasuminen: { data: [], description: '' },
  },
});

// hard-coded pharmacy organization
export const organizationTemplate = () => ({
  'e3823055-7c0c-4115-8059-c43313de961d': {
    businessCode: '0202094-5',
    name: 'Apteekit',
    summary: 'Paikkakuntasi apteekkipalvelut.',
    description:
      'Suomen Apteekkariliitto kehittää ammatillisesti ja eettisesti korkeatasoista apteekkitoimintaa osana terveydenhuoltoa ja tuottaa jäsenilleen apteekkiliikkeen harjoittamista tukevia palveluita.\n\nLähes kaikki Suomen apteekkarit kuuluvat vuonna 1897 perustettuun Apteekkariliittoon.',
    emails: [],
    phoneNumbers: [],
    webPages: [{ url: 'https://www.apteekki.fi/' }],
    addresses: [],
    availableServices: ['apteekit'],
  },
});

// Municipalities codes mapped to pharmacy serviceChannel ids
// fetched manually from: https://api.palvelutietovaranto.suomi.fi/api/v11/ServiceChannel/list/area/Municipality/code/<CODE>?page=1
export const pharmacyMunicipalityMap = {
  '050': [
    'd2cc6d55-0534-4c58-8cc0-c72c1d84eab5',
    '3b874cf6-763b-4087-90e4-c7703a39dc83',
    '4abe5de9-347f-4a66-9e4e-0090b5a80c87',
  ],
  '051': ['fb1a8ea7-a523-43a9-8cf6-eebe3ef0d5f7'],
  '079': ['e10bd7e3-c160-49d8-8ef9-596b40a1e520'],
  102: ['d38d27fe-2256-4fc0-ab5a-f76026ecc2b7'],
  181: ['fb6cde74-ae6a-4b27-977e-55340930d4c5'],
  214: [
    'cc3dc044-07a9-4d5e-9687-a2e2c55133eb',
    '458e555c-3a22-44ce-b891-eb2f1ccea509',
    '6a85c4bb-5af4-43db-a909-f3fdcbd23b17',
  ],
  230: ['b7773f7f-7bbb-4ce7-86b2-efcbf180bba1'],
  271: [
    '36750c60-a1fa-4585-a04c-fa4021efb857',
    '5dad4f3c-0a91-4c77-ba48-e48bdd567826',
    '6e9685cc-1525-4e07-9d86-dfbab9f87cea',
  ],
  484: ['66231a19-fd19-4f34-899c-fb9b55e2039e'],
  531: ['311881ec-1921-45be-a0c6-f5f495817c32'],
  608: ['6465c54f-8dd3-452d-8cf7-f96f9aa28874'],
  609: [
    '7ebb16a8-7d8b-4b13-a4d2-332c5fe4059f',
    '7dcf48f2-09dd-4905-b70c-75812eba089b',
    '5b13ad05-a545-4fbd-af5f-4e29e32854d5',
    'e63e9e3e-7aa5-4fd4-b8f9-29434917d971',
    'dc63950a-6229-45e6-b7aa-06cd1b9d1358',
    '3a6114f1-dc65-44b7-a570-903cb8c28300',
    'b8ed52a0-a779-460d-a397-f3d288dd170b',
    'a955879e-b470-4e93-854f-e5d8c3813fca',
    '6107a746-2d58-47b1-b5b3-feceb0b9efcb',
    '086765a7-815d-455c-8554-d3500208363e',
    '1c3f7663-4fad-4e96-89dd-51405ee89e94',
    '02bc94ed-5790-4f24-ba45-367aa68e0754',
    '039f8584-f9b3-43d3-8780-7a4aaca68e9e',
    'b3269693-3de9-44a3-aec3-b6edb7b79afe',
    '01851be5-6c38-428c-9c88-b703f2366106',
  ],
  684: [
    'e09b01ed-e5cd-4be1-8a9b-6e6a686159da',
    'c6184ca2-a2f6-4bf6-be7d-f231b730ad9b',
    'eb543108-f253-4541-a345-e2a8a3af8d83',
    'f1287611-9109-4268-9b91-7abb2ad46d36',
    'd071994f-f374-454f-aa3a-1b895bdedec1',
    'e0e04013-1f2f-4e5c-a745-0d8b56ac5da0',
    'ce0bee1a-64ac-4fed-9dce-15fc9c806e15',
  ],
  747: ['99ded5c2-ed6c-4fd9-99e3-7fba2c6733e9'],
  783: [
    'a678c073-b5d2-4d80-b6cb-aab719b7b082',
    'd9413561-4d71-4429-a2d2-9c5c5f216f88',
  ],
  886: ['e5b154e6-bac3-41d0-84a7-6957608cc2d1'],
};

export const extraFilters = [
  'ruotsi', // -> itemList.languages
  'englanti', // -> itemList.languages
  // -- Comment out 'palveluseteli' until there is content
  // 'palveluseteli', // -> itemList.(serviceVoucherInUse / serviceVoucher)
  'maksuton', // -> itemList.serviceChargeType
];

export const satakuntaCodes = [
  {
    names: [
      {
        value: 'Valitse kunta',
      },
    ],
    code: '000',
  },
  {
    names: [
      {
        value: 'Eura',
      },
    ],
    code: '050',
  },
  {
    names: [
      {
        value: 'Eurajoki',
      },
    ],
    code: '051',
  },
  {
    names: [
      {
        value: 'Harjavalta',
      },
    ],
    code: '079',
  },
  {
    names: [
      {
        value: 'Huittinen',
      },
    ],
    code: '102',
  },
  {
    names: [
      {
        value: 'Jämijärvi',
      },
    ],
    code: '181',
  },
  {
    names: [
      {
        value: 'Kankaanpää',
      },
    ],
    code: '214',
  },
  {
    names: [
      {
        value: 'Karvia',
      },
    ],
    code: '230',
  },
  {
    names: [
      {
        value: 'Kokemäki',
      },
    ],
    code: '271',
  },
  {
    names: [
      {
        value: 'Merikarvia',
      },
    ],
    code: '484',
  },
  {
    names: [
      {
        value: 'Nakkila',
      },
    ],
    code: '531',
  },
  {
    names: [
      {
        value: 'Pomarkku',
      },
    ],
    code: '608',
  },
  {
    names: [
      {
        value: 'Pori',
      },
    ],
    code: '609',
  },
  {
    names: [
      {
        value: 'Rauma',
      },
    ],
    code: '684',
  },
  {
    names: [
      {
        value: 'Siikainen',
      },
    ],
    code: '747',
  },
  {
    names: [
      {
        value: 'Säkylä',
      },
    ],
    code: '783',
  },
  {
    names: [
      {
        value: 'Ulvila',
      },
    ],
    code: '886',
  },
];

export const colors = {
  primary: '#178287',
  primaryDark: '#0d5a5d',
  primaryBackground: '#e8f2f3',
  secondary: '#8651c7',
  secondaryDark: '#543282',
  secondaryBackground: '#f3edf9',
};
